import axios from 'axios';

import Vue from 'vue';

import { sync } from 'vuex-router-sync';

import showdown from 'showdown';

import VuePaginate from 'vue-paginate';
import Paginate from 'vuejs-paginate';
import VueClipboard from 'vue-clipboard2';
import InfiniteLoading from 'vue-infinite-loading';
import ToggleButton from 'vue-js-toggle-button';

import dayjs from 'dayjs';

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

import VueGtag from 'vue-gtag';

import App from './App.vue';
import './components';
import constants from './constants';
import './registerServiceWorker';
import router from './router';
import store from './store';


const unsync = sync(store, router);

Vue.config.productionTip = false;
axios.defaults.baseURL = constants.apiBaseUrl;

if (store.state.Auth.token) {
  axios.defaults.headers.common.Accept = 'application/json';
  axios.defaults.headers.common.Authorization = `Bearer ${store.state.Auth.token}`;
}

Vue.use(VuePaginate);
Vue.component('paginatejs', Paginate);
Vue.use(VueClipboard);
Vue.use(InfiniteLoading, { /* options */ });
Vue.use(ToggleButton);

const markdownConverter = new showdown.Converter();
markdownConverter.setFlavor('github');
Vue.filter('md2html', (value) => {
  if (!value) return '';

  return markdownConverter.makeHtml(value.toString());
});

Vue.filter('currencyFormatFilter', (value) => {
  if (!value) return '';
  return value
    .toFixed(2)
    .replace(/\.00$/, '')
    .toString()
    .split([''])
    .reverse()
    .join('')
    .match(/.{1,3}/g)
    .join(' ')
    .split('')
    .reverse()
    .join('');
});

Vue.filter('num2KES', (value) => {
  if (!value) return '';
  return value
    .toString()
    .split([''])
    .reverse()
    .join('')
    .match(/.{1,3}/g)
    .join(' ')
    .split('')
    .reverse()
    .join('');
});

Vue.filter('num2CommaSaparatedKES', (value) => {
  if (!value) return '';
  return value
    .toString()
    .split([''])
    .reverse()
    .join('')
    .match(/.{1,3}/g)
    .join(',')
    .split('')
    .reverse()
    .join('');
});

Vue.filter('uppercase', (value) => {
  if (!value) return '';
  return value
    .toUpperCase();
});

Vue.filter('lowercase', (value) => {
  if (!value) return '';
  return value
    .toLowerCase();
});

Vue.filter('capitalize', (value) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase()
    + value.slice(1).toLowerCase();
});

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);

Vue.prototype.$saveAs = (uri, filename) => {
  const link = document.createElement('a');

  if (typeof link.download === 'string') {
    link.href = uri;
    link.download = filename;

    // Firefox requires the link to be in the body
    document.body.appendChild(link);

    // simulate click
    link.click();

    // remove the link when done
    document.body.removeChild(link);
  } else {
    window.open(uri);
  }
};

Vue.prototype.$download = (ref, downloadType, filename) => {
  const { clientWidth } = ref;
  const { clientHeight } = ref;

  html2canvas(ref, {
    scrollX: 0,
    scrollY: (window.pageYOffset * -1),
  }).then((canvas) => {
    const img = canvas.toDataURL('image/jpeg', 1);
    if (downloadType === 'pdf') {
      // eslint-disable-next-line new-cap
      const doc = new jsPDF('p', 'pt', [clientWidth, clientHeight]);
      doc.addImage(img, 'PNG', 0, 0, clientWidth, clientHeight);
      doc.save(filename);
    } else {
      Vue.prototype.$saveAs(img, filename);
    }
  });
};

axios.interceptors.response.use(
  res => res,
  (error) => {
    if (!error.response) {
      console.log(error);
      return Promise.reject(error);
    }
    const { status } = error.response;

    // eslint-disable-next-line
    console.log(error.response.data);
    if (status === 401) {
      store.commit('Auth/clearToken');
      if (!['/', '/auth/login', '/auth/signup'].includes(window.location.pathname)) {
        window.location.href = '/auth/signup';
      }
    }

    return Promise.reject(error.response);
  },
);

Vue.filter('filterDate', (value) => {
  if (!value) return '';
  return ` ${dayjs(value).format('DD MMM YYYY HH:mm')}`;
});
Vue.filter('dateView', (value) => {
  if (!value) return '';
  return ` ${dayjs(value).format('DD MMM YYYY')}`;
});

Vue.use(VueGtag,
  {
    config: {
      id: constants.gaMeasurementId,
      params: {
        send_page_view: true,
      },
    },
  },
  router);

Vue.prototype.$track = (action, callback) => {
  const createFunctionWithTimeout = (callbackFn) => {
    const optTimeout = 1000;
    let called = false;
    function fn() {
      if (!called) {
        called = true;
        callbackFn();
      }
    }
    setTimeout(fn, optTimeout || 1000);
    return fn;
  };
  Vue.prototype.$gtag.event(action,
    {
      event_callback:
        createFunctionWithTimeout(callback),
    });
};

new Vue({
  router,
  store,
  render: h => h(App),
  unmount() {
    unsync();
  },
}).$mount('#app');
